import { Button } from "@shapr3d/frontend-lib";

import useNavigation from "../../hooks/navigation";
import useTranslation from "../../hooks/useTranslation";
import { NewZendeskTicketLink } from "../NewZendeskTicketLink/NewZendeskTicketLink";

import style from "./VerifyEmailConfirmation.module.css";

interface VerifyEmailConfirmationProps {
  success: boolean;
  edu: boolean;
}

const VerifyEmailConfirmation: React.FC<VerifyEmailConfirmationProps> = ({ success, edu }) => {
  const { goToProfile } = useNavigation();
  const { t, m } = useTranslation();
  return (
    <div className={style.container}>
      <img
        src="https://s3-eu-west-1.amazonaws.com/shapr3d-assets/images/engine-model.png"
        alt={t(m.VerifyEmailConfirmation.IllustrationAlt)}
        className={style.illustration}
      />
      <div className={style.message}>
        {success ? (
          <>
            {!edu && <div>{t(m.VerifyEmailConfirmation.SuccessConfirmed)}</div>}
            {edu && <div>{t(m.VerifyEmailConfirmation.SuccessEdu)}</div>}
          </>
        ) : (
          <div>
            {t(m.VerifyEmailConfirmation.SomethingWentWrong, {
              link: (chunks) => (
                <NewZendeskTicketLink>
                  <span className={style.link}>{chunks}</span>
                </NewZendeskTicketLink>
              ),
            })}
          </div>
        )}
      </div>
      <Button onClick={() => goToProfile()}>{t(m.Edu.BackToMyProfile)}</Button>
      {edu && (
        <div className={style.disclaimer}>
          {t(m.VerifyEmailConfirmation.EduDisclaimer, {
            strong: (chunks) => <strong>{chunks}</strong>,
          })}
        </div>
      )}
    </div>
  );
};

export default VerifyEmailConfirmation;
